<style lang='less'>
  .queryUser{
    .dialog-header{
      display: flex;
      margin-bottom: 20px;
      .dialog-input{
        width: 200px;
        margin-right: 10px;
      }
    }
    .dialog-body{
      overflow: hidden;
      .dialog-pagination{
        float: right;
        margin: 10px 0;
      }
    }
    .dialog-footer{
      display: flex;
      flex-direction: row-reverse;
      .dialog-btn{
        margin-left: 10px;
      }
    }
  }
</style>
<template>
  <el-dialog :visible.sync="dTableVisible" :before-close="cancel" size="large" top="18%" class="queryUser" title="接口服务查询">
      <div class="dialog-header">
        <el-input size="small"
          v-model="ServerID"
          placeholder="服务ID/名称查询"
          @keyup.enter.native="loadServerApi"
          class="dialog-input"></el-input>
        <el-select v-model="ServerTypeID" placeholder="服务类型" size="small" class="dialog-input">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" @click="loadServerApi">查询</el-button>
      </div>
      <div class="dialog-body">
      <el-table :data="tableData" max-height="350"  @selection-change="handleSelectionChange" v-loading='loading'>
        <el-table-column type="selection" width="55"></el-table-column>
        <template v-for="(item, index) in dictionaryArr">
          <el-table-column
            :key="index"
            :prop="item"
            :label="dictionary[item]"
            min-width="150">
            <template slot-scope='scopestatus'>
              <el-tag type="success" v-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 0 ">启用</el-tag>
              <el-tag type="warning" v-else-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 2">维护</el-tag>
              <el-tag type="gray" v-else-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 1">禁用</el-tag>
              <span v-else-if="item === 'ServerType'">{{scopestatus.row['ServerTypeID']}}.{{scopestatus.row[item]}}</span>
              <span v-else>{{scopestatus.row[item]}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
          class="dialog-pagination"
          @size-change = 'queryNewSize'
          @current-change = 'queryNewPage'
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      <div class="dialog-footer">
        <el-button class="dialog-btn" @click="cancel" size="small">取消</el-button>
        <el-button class="dialog-btn" type="primary" @click="continues" size="small">确认继续</el-button>
        <el-button class="dialog-btn" type="primary" @click="confirm" size="small">确认</el-button>
      </div>
  </el-dialog>
</template>
<script>
  import util from '../../../util.js';
  import {TableData} from '../../../vuex/actions'
  export default {
    props:['dialogTableVisible', 'appid'],
    vuex: {
      getters: {
      },
      actions: {
        TableData
      }
    },
    data() {
      return {
        loading: false,
        totalCount: 0,
        //查询参数
        ServerTypeID: '',
        ServerID: '',
        AppID: this.appid,
        currentPage: 1,
        pageSize: 10,
        /**************/
        multipleSelection: [],
        tableData: [],
        dictionaryArr:[],
        dTableVisible:this.dialogTableVisible,
        options: [{
          value: '1',
          label: '1.StdQuery'
        }, {
          value: '2',
          label: '2.DataObject'
        }, {
          value: '3',
          label: '3.Business'
        }],
      };
    },
    watch:{
      'dialogTableVisible' : function(){
        this.dTableVisible = this.dialogTableVisible
        if(this.dialogTableVisible){
          this.loadServerApi();
        }
      },
      'appid': function () {
        this.AppID = this.appid
      }
    },
    mounted(){
    },
    methods:{
      queryNewSize (size) {
        this.pageSize = size
        this.loadServerApi()
      },
      queryNewPage (Page) {
        this.currentPage = Page
        this.loadServerApi()
      },
      loadServerApi(){
        let params = {
          queryName: 'GetOAuthSrv',
          AppID: this.AppID,
          ServerID: this.ServerID,
          ServerTypeID: this.ServerTypeID,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
        this.loading = true
        this.TableData(params, (res) => {
          this.loading = false
          if (res.isValid && res.data.isValid){
            this.tableData = res.data.dataList
            this.dictionary = res.data.dictionary
            this.dictionaryArr = filterArr(res.data.dictionary, res.data.hideFields)
            this.totalCount = res.totalCount
          }
        })
      },
      handleSelectionChange(val){
        this.multipleSelection = val;
      },
      cancel:function () {
        this.dTableVisible = false;
        this.$emit('update:dialogTableVisible', false);
      },
      confirm:function () {
        this.$emit('passtabledata', this.multipleSelection)
        this.dTableVisible = false;
        this.$emit('update:dialogTableVisible', false);
      },
      continues:function () {
        this.$emit('passtabledata', this.multipleSelection)
      },
    }
  }

  function filterArr(dicArr, hideArr){
    //console.log(Object.keys(dicArr));console.log(hideArr);
    let hide = hideArr.split(';')
    let arr = []
    for(var i in dicArr){
      //console.log(i)
      if(!hide.includes(i)){
        arr.push(i)
      }
    }
    return arr
  }
</script>




// WEBPACK FOOTER //
// queryUser.vue?709400cd